import { render, staticRenderFns } from "./CheckVideo.vue?vue&type=template&id=601bf8cf&scoped=true&"
import script from "./CheckVideo.vue?vue&type=script&lang=ts&"
export * from "./CheckVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601bf8cf",
  null
  
)

export default component.exports